module.exports = __webpack_public_path__ + "static/img/m11.46f4015.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-edge/mobile/m11.png
// module id = 0svn
// module chunks = 12